import { z } from "zod";
import { environmentConfigurationSchema } from "./environmentSchema";

// All PUBLIC_* configuration arrives via window.__ODIN_RUNTIME_CONFIG__,
// populated by docker-entrypoint.sh at container startup (or by
// webpack-dev-server in local dev). Nothing is read from import.meta.env, so the
// same JS bundle runs in any environment.
//
// The global is Odin-namespaced (not the generic __RUNTIME_CONFIG__) because
// Odin also runs as a module-federation remote inside other hosts (e.g.
// core-ui). A remote executes in the host's page, so it must read its OWN config
// rather than the host's. docker-entrypoint.sh therefore sets this global both
// in index.html (standalone) and by prepending it to remoteEntry.js (federated,
// loaded from Odin's origin).
const RUNTIME_CONFIG = window.__ODIN_RUNTIME_CONFIG__ ?? {};

const createConfigurationContainer = () => {
    try {
        return environmentConfigurationSchema.parse(RUNTIME_CONFIG);
    } catch (error) {
        if (error instanceof z.ZodError) {
            const errorMessages = error.errors
                .map(err => `${err.path.join(".")}: ${err.message}`)
                .join("\n");

            throw new Error(
                `Environment validation failed:\n${errorMessages}\n\nPlease ensure all required environment variables are properly configured.`,
            );
        }
        throw error;
    }
};

export const configurationContainer = createConfigurationContainer();
